import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import styled from 'styled-components'

export const MultiLineDndContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const BetweenLinesGap = styled.div<{
  $isOver: boolean
  $isDragging: boolean
}>`
  position: relative;
  width: 100%;
  min-height: 7px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  opacity: 1;
  background-color: ${COLORS.white} !important;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    border-radius: 1px;
    background-color: ${COLORS.primary};
    opacity: ${({ $isDragging, $isOver }) =>
      !$isDragging ? 0 : $isOver ? 1 : 0.3};
    transition: opacity 0.15s ease;
  }
`

export const DropLine = styled.div<{ $isVisible: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};
`

export const DropIndicator = styled.div`
  display: none;
  position: absolute;
  top: 0;
  height: 100%;
  background-color: ${COLORS.primary};
  border: 1px solid ${COLORS.borderColor};
  opacity: 0.2;
  border-radius: ${RADII.item};
  pointer-events: none;
`
